<template>
    <div class="container webLogo spaceBetween">
        <a class="logo fl" href="/"><i class="icons-logoD"></i>{{ appName }}<img src="/files?imagePath=/banner/logo_title.png" alt=""></a>
        <div class="nav clearfix" :class="{'active' : showMenu}" @click="showMenu = true">
            <ul id="menu" class="menu">
                <li @click.stop="showMenu = false"><router-link active-class="on" to="/index">首页</router-link></li>
                <li @click.stop="showMenu = false"><router-link active-class="on" to="/jobList">找工作</router-link></li>
                <li @click.stop="showMenu = false"><router-link active-class="on" to="/moreResume">找人才</router-link></li>
                <!--<li @click.stop="showMenu = false"><router-link active-class="on" to="/job">人才大厅</router-link></li>-->
                <!--<li @click.stop="showMenu = false"><router-link active-class="on" to="/project">项目服务</router-link></li>-->
                <!--<li @click.stop="showMenu = false"><router-link active-class="on" to="/studio">智能工作室</router-link></li>-->
                <li @click.stop="showMenu = false"><router-link active-class="on" to="/about">关于我们</router-link></li>
            </ul>
        </div>
        <!-- <div id="search" class="search fr">
            <input type="text" placeholder="搜索职位" value="" maxlength="50" autocomplete="off" class="searchCon" id="searchInput" v-model="positionName">
            <router-link id="searchBtn" class="searchMenu" :to="{path:'/jobList',query:{name:positionName}}" ><i class="icons-search"></i></router-link>
        </div> -->
    </div>
</template>
<script>
    export default {
        data() {
            return {
                appName: "",
                positionName:'',
                showMenu: false,
            }
        },
        created() {
            if(this.Cookies.get('APP_HEADER_NAME')){
                this.appName = decodeURI(this.Cookies.get('APP_HEADER_NAME'));
            }
        },
        methods: {

        }
    };
</script>
